import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg viewBox="0 0 1024 1024" width="1em" height="1em" focusable="false" fill="currentColor" aria-hidden="true"><path d="M960 64c35.392 0 64 33.28 64 74.24v217.152c0 41.024-28.672 74.304-64 74.304H64c-35.328 0-64-33.28-64-74.24V138.24C0 97.216 28.672 64 64 64h896zM352.512 199.04H159.488c-11.264 0-21.632 6.4-27.264 16.832a35.84 35.84 0 0 0 0 33.792c5.632 10.432 16 16.896 27.264 16.896h193.024c17.408 0 31.488-15.168 31.488-33.792 0-18.624-14.08-33.728-31.488-33.728zM960 576c35.392 0 64 33.28 64 74.24v217.152c0 41.024-28.672 74.304-64 74.304H64c-35.328 0-64-33.28-64-74.24V650.24C0 609.216 28.672 576 64 576h896zM352.512 711.04H159.488c-11.264 0-21.632 6.4-27.264 16.832a35.84 35.84 0 0 0 0 33.792c5.632 10.432 16 16.896 27.264 16.896h193.024c17.408 0 31.488-15.168 31.488-33.792 0-18.624-14.08-33.728-31.488-33.728z" /></svg>

const Devices = React.forwardRef((props, ref) => {
  return (
    <IconBase name="devices" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

Devices.displayName = 'IconDevices'

export default Devices
